import {
  useEffect,
  useState
} from "react";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  BarChart,
  Bar
} from "recharts";

import API from "../../services/api";

function SalesReport() {

  const [summary,
    setSummary] =
    useState({});

  const [monthly,
    setMonthly] =
    useState([]);

  const [topProducts,
    setTopProducts] =
    useState([]);

  const [sales,
    setSales] =
    useState([]);

  const [page,
    setPage] =
    useState(1);

  const [pages,
    setPages] =
    useState(1);

  const [search,
    setSearch] =
    useState("");

  useEffect(() => {
    loadData();
  }, [page, search]);

  const loadData =
    async () => {

      try {

        const [
          summaryRes,
          monthlyRes,
          topRes,
          salesRes
        ] =
          await Promise.all([
            API.get(
              "/sales-report/summary"
            ),
            API.get(
              "/sales-report/monthly"
            ),
            API.get(
              "/sales-report/top-products"
            ),
            API.get(
              `/sales-report/list?page=${page}&search=${search}`
            )
          ]);

        setSummary(
          summaryRes.data
        );

        setMonthly(
          monthlyRes.data
        );

        setTopProducts(
          topRes.data
        );

        setSales(
          salesRes.data.sales
        );

        setPages(
          salesRes.data.pages
        );

      } catch (err) {
        console.log(err);
      }

    };

  return (
    <div>

      <h1
        className="
        text-4xl
        font-bold
        mb-6
      "
      >
        Sales Report
      </h1>

      {/* CARDS */}

      <div
        className="
        grid
        md:grid-cols-3
        gap-6
        mb-8
      "
      >

        <div
          className="
          bg-[#111]
          rounded-2xl
          p-6
        "
        >
          <p>
            Total Revenue
          </p>

          <h2
            className="
            text-3xl
            text-green-400
            font-bold
          "
          >
            ₹
            {Number(
              summary.totalRevenue || 0
            ).toFixed(2)}
          </h2>
        </div>

        <div
          className="
          bg-[#111]
          rounded-2xl
          p-6
        "
        >
          <p>
            Total GST
          </p>

          <h2
            className="
            text-3xl
            text-yellow-400
            font-bold
          "
          >
            ₹
            {Number(
              summary.totalGST || 0
            ).toFixed(2)}
          </h2>
        </div>

        <div
          className="
          bg-[#111]
          rounded-2xl
          p-6
        "
        >
          <p>
            Total Invoices
          </p>

          <h2
            className="
            text-3xl
            text-blue-400
            font-bold
          "
          >
            {
              summary.totalInvoices || 0
            }
          </h2>
        </div>

      </div>

      {/* CHARTS */}

      <div
        className="
        grid
        lg:grid-cols-2
        gap-6
        mb-8
      "
      >

        <div
          className="
          bg-[#111]
          rounded-2xl
          p-5
        "
        >
          <h2
            className="
            text-xl
            font-bold
            mb-4
          "
          >
            Monthly Sales
          </h2>

          <ResponsiveContainer
            width="100%"
            height={300}
          >
            <LineChart
              data={monthly}
            >
              <CartesianGrid
                strokeDasharray="3 3"
              />

              <XAxis
                dataKey="month"
              />

              <YAxis />

              <Tooltip />

              <Line
                type="monotone"
                dataKey="total"
                stroke="#eab308"
                strokeWidth={3}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div
          className="
          bg-[#111]
          rounded-2xl
          p-5
        "
        >
          <h2
            className="
            text-xl
            font-bold
            mb-4
          "
          >
            Top Products
          </h2>

          <ResponsiveContainer
            width="100%"
            height={300}
          >
            <BarChart
              data={topProducts}
            >
              <CartesianGrid
                strokeDasharray="3 3"
              />

              <XAxis
                dataKey="name"
              />

              <YAxis />

              <Tooltip />

              <Bar
                dataKey="qty"
                fill="#22c55e"
              />
            </BarChart>
          </ResponsiveContainer>
        </div>

      </div>

      {/* SEARCH */}

      <input
        placeholder="Search Invoice..."
        value={search}
        onChange={(e)=>
          setSearch(
            e.target.value
          )
        }
        className="
        w-full
        md:w-80
        p-3
        bg-[#111]
        rounded-xl
        mb-6
      "
      />

      {/* TABLE */}

      <div
        className="
        bg-[#111]
        rounded-2xl
        overflow-hidden
      "
      >

        <div
          className="
          overflow-x-auto
        "
        >

          <table
            className="
            w-full
          "
          >

            <thead>
  <tr
    className="
    border-b
    border-yellow-500/20
  "
  >
    <th className="p-4 text-left">
      Invoice
    </th>

    <th className="p-4 text-left">
      Customer
    </th>

    <th className="p-4 text-left">
      Date
    </th>

    <th className="p-4 text-left">
      Amount
    </th>
  </tr>
</thead>

            <tbody>

              {sales.map(
                (item) => (

                  <tr
                    key={item.id}
                    className="
                    border-b
                    border-yellow-500/10
                  "
                  >

                    <td className="p-4">
                      {
                        item.invoice_no
                      }
                    </td>

                    <td className="p-4">
                      {
                        item.customer_name
                      }
                    </td>

                    <td className="p-4">
                      {
                        new Date(
                          item.created_at
                        )
                          .toLocaleDateString()
                      }
                    </td>

                    <td className="p-4">
                      ₹
                      {
                        item.grand_total
                      }
                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

      </div>

      {/* PAGINATION */}

      <div
        className="
        flex
        gap-2
        mt-6
      "
      >

        {[...Array(pages)]
          .map(
            (_, i) => (

              <button
                key={i}
                onClick={() =>
                  setPage(
                    i + 1
                  )
                }
                className={`
                  px-4 py-2 rounded-lg
                  ${
                    page === i + 1
                      ? "bg-yellow-500 text-black"
                      : "bg-[#111]"
                  }
                `}
              >
                {i + 1}
              </button>

            )
          )}

      </div>

    </div>
  );
}

export default SalesReport;